import { ToastrService } from 'ngx-toastr';
import { encryptPassword } from 'src/app/constant/globalFunction';
import { ChangeDetectorRef, Component, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../services/login.service';
import { CaptchaService } from '../shared/captcha/captcha.service';
import { CAPTCHA_CONFIG } from '../../utils/captcha-config';
import { CaptchaComponent } from '../shared/captcha/captcha.component';
import { CAPTCHA_IS_REQUIRED_MSG, CAPTCHA_MSG, HREF_LINK, IMPORTANT_DATE, IMPORTANT_MESSAGE, INVALID_CREDENTIALS_MSG, LOGIN_FAILED_MSG, PASSWORD_IS_REQUIRED_MSG, PASSWORD_VALID_MSG, UNABLE_TO_CONNECT_MSG, USER_NAME_MAX_LENGTH, USER_NAME_MAX_LENGTH_MSG, USER_NAME_REQUIRED_MSG, USER_NAME_VALID_MSG } from '../../constant/responseMessage';
import { COOKIE_KEYS, copyRight, envName, LOGIN_TEXT, NO_SPACE_PATTERN, OBJECT, USER_NAME_PATTERN, DEV_PROFILE, JSESSIONID, MOBILE_PLATFORM, STUDY_AND_ROLE_ROUTE, UNAUTHORIZED, BAD_CREDENTIALS, USER_NOT_FOUND } from '../../constant/constant';
import { ConfigurationService } from '../../services/configuration.service';
import { HttpErrorResponse } from '@angular/common/http';
import  { CookieService } from 'ngx-cookie-service';
import { AuthBaseService } from '../../services/auth-base.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})  



export class LoginComponent implements OnInit,OnChanges {

  @ViewChild(CaptchaComponent) captchaCompo:any;
  formGroup!: FormGroup;
  loading: boolean = false;
  isVisiblePassword: boolean = false;
  type: string = 'password';
  copyRight: string = copyRight;
  appVersion: string = '';
  captchaStatus: any = null;
  captchaConfig: any = CAPTCHA_CONFIG;
  roleId: number = -1;
  IMPORTANT_MESSAGE = IMPORTANT_MESSAGE;
  IMPORTANT_DATE = IMPORTANT_DATE;
  HREF_LINK = HREF_LINK;
  DEV_PROFILE = DEV_PROFILE;
  environment = envName;
  isLoggedIn: boolean = false;
  usernameError: string = '';
  passwordError: string = '';
  loginError: string = '';
  loginText: string = LOGIN_TEXT;

  constructor(private loginAPI:LoginService, private route:Router, private toastr:ToastrService, private captchaService:CaptchaService, private activatedRoute: ActivatedRoute,
    private cookieService: CookieService, private changeDetectorRef: ChangeDetectorRef, private authBaseService: AuthBaseService,
    private configurationService: ConfigurationService
  ) {}
  
  ngOnChanges(): void {
    this.captchaConfig = CAPTCHA_CONFIG;
  }

  getStorageData(): void {
    this.roleId = Number(this.cookieService.get(COOKIE_KEYS.ROLE) || -1);
  }

  ngOnInit(): void {
    this.getStorageData();
    this.configurationService.appVersion$.subscribe(version => this.appVersion = version);
    this.initForm();
    this.activatedRoute.queryParams.subscribe((params) => {
      const authCode = params['code'];
      const mobilePlatform: string = params[MOBILE_PLATFORM];
      if (mobilePlatform) {
        sessionStorage.setItem(MOBILE_PLATFORM, mobilePlatform);
      }
      let isAuthorized:boolean = this.cookieService.get(COOKIE_KEYS.USER_ID) ? true : false;
      if (authCode && !isAuthorized) {
        const isMobilePlatform = sessionStorage.getItem(MOBILE_PLATFORM);
        this.isLoggedIn = isMobilePlatform != 'true';
        if (isMobilePlatform == 'true') {
          const sessionId: string = sessionStorage.getItem(JSESSIONID) || '';
          sessionStorage.removeItem(MOBILE_PLATFORM);
          sessionStorage.removeItem(JSESSIONID);
          window.location.replace(`EDCMobileApp://auth/callback?code=${authCode}&JSESSIONID=${sessionId}`);
          return;
        }
        this.handleOAuthCallback(authCode);
      } else {
        this.handleInitialLoad(isAuthorized);
      }
    });
  }

  initForm() {
    const formControls: any = {
      username: new FormControl('', [
        Validators.required,
        Validators.pattern(USER_NAME_PATTERN),
        Validators.pattern(NO_SPACE_PATTERN),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.pattern(NO_SPACE_PATTERN),
      ]),
      grant_type: new FormControl('password'),
    };

    if (this.environment !== DEV_PROFILE) {
      formControls['captchaData'] = new FormControl('');
    }

    this.formGroup = new FormGroup(formControls);
  }

  validateLoginCredentials() {
    const usernameControl = this.formGroup?.get('username');
    const passwordControl = this.formGroup?.get('password');

    let data = this.formGroup?.value;
    let dataStatus: boolean = true;

    if (DEV_PROFILE !== this.environment) {
      if (
        !this.captchaCompo.captch_input ||
        this.captchaCompo.captch_input.toString().trim() === ''
      ) {
        this.captchaCompo.invalidCaptchaErr = CAPTCHA_IS_REQUIRED_MSG;
        dataStatus = false;
      } else if (
        this.captchaCompo.captch_input != this.captchaCompo.resultCode
      ) {
        this.captchaCompo.invalidCaptchaErr = CAPTCHA_MSG;
        dataStatus = false;
      } else {
        this.captchaService.captchStatus.subscribe((status: any) => {
          this.formGroup?.get('captchaData')?.setValue(status);
          if (!this.formGroup?.get('captchaData')?.value) {
            dataStatus = status;
          }
        });
      }
    }
    if (usernameControl?.hasError('required')) {
      this.usernameError = USER_NAME_REQUIRED_MSG;
      this.refreshCaptcha();
      dataStatus = false;
    } else if (usernameControl?.hasError('pattern')) {
      this.usernameError = USER_NAME_VALID_MSG;
      this.refreshCaptcha();
      dataStatus = false;
    } else {
      if (data.username.length !== USER_NAME_MAX_LENGTH) {
        this.usernameError = '';
      }
    }

    if (passwordControl?.hasError('required')) {
      this.passwordError = PASSWORD_IS_REQUIRED_MSG;
      this.refreshCaptcha();
      dataStatus = false;
    } else if (passwordControl?.hasError('pattern')) {
      this.passwordError = PASSWORD_VALID_MSG;
      this.refreshCaptcha();
      dataStatus = false;
    } else {
      this.passwordError = '';
    }
    return dataStatus;
  }

  loginProcess(): void {
    if (!this.validateLoginCredentials()) {
      this.loading = false;
      return;
    }

    const loginData = {
      username: this.formGroup.value.username,
      password: encryptPassword(this.formGroup.value.password),
    };
    this.loading = true;

    this.loginAPI.login(loginData).subscribe({
      next: (res) => {
        const mobilePlatform = sessionStorage.getItem(MOBILE_PLATFORM);
        sessionStorage.clear();
        localStorage.clear();
        const sessionId = res.responseObject.JSESSIONID;
        this.loading = false;
        if (mobilePlatform == 'true') {
          sessionStorage.setItem(MOBILE_PLATFORM, 'true');
          sessionStorage.setItem(JSESSIONID, sessionId);
        }
        this.changeDetectorRef.detectChanges();
        window.location.replace(res.responseObject.authorizationUrl);
      },
      error: (err: HttpErrorResponse) => {
        if (err.status === 0) {
        } else if (err.error && typeof err.error === OBJECT) {
          if (err.error?.error === UNAUTHORIZED) {
            this.loginError = this.getErrorMessage(err);
          } else {
            this.toastr.error(err.error.message || UNABLE_TO_CONNECT_MSG);
          }
        } else {
          this.toastr.error(LOGIN_FAILED_MSG);
        }
        this.formGroup.reset();
        this.isLoggedIn = false;
        this.loading = false;
        this.refreshCaptcha();
      },
    });
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    const errMessage: string = err.error.message;
    if (errMessage == BAD_CREDENTIALS || errMessage.includes(USER_NOT_FOUND) ) {
      return INVALID_CREDENTIALS_MSG;
    }
    return errMessage || LOGIN_FAILED_MSG;
  }

  private handleOAuthCallback(code: string): void {
    this.loginAPI.exchangeCodeForToken(code).subscribe({
      next: (response) => {
        this.processOAuthResponse(response);
      },
      error: (err) => {
        this.toastr.error(err.error?.message || 'An error occurred');
        this.loading = false;
      },
    });
  }

  private processOAuthResponse(response: any): void {
    if (response.status !== 0 || !response.responseObject?.authenticated) {
      this.toastr.error(response.message);
      this.loading = false;
      this.route.navigate(['']);
      return;
    }
    this.loading = false;
    this.authBaseService.broadcastLogin();
    this.route.navigate([STUDY_AND_ROLE_ROUTE], { replaceUrl: true });
  }

  private handleInitialLoad(isAuthorized: boolean): void {
    this.loading = false;
    if (isAuthorized) {
      if (this.route.url !== `/${STUDY_AND_ROLE_ROUTE}`) {
        this.route.navigate([STUDY_AND_ROLE_ROUTE], { replaceUrl: true });
      } else {
        this.isLoggedIn = true;
        this.changeDetectorRef.detectChanges();
      }
    } else {
      this.isLoggedIn = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  onCaptchaResult(value: string): void {
    this.formGroup?.get('captchaData')?.setValue(value);
  }

  onUserNameChange(event: Event | null | undefined): void {
    const input = event?.target as HTMLInputElement;
    const usernameValue = input?.value || '';
    this.loginError = '';
    if (usernameValue.length === USER_NAME_MAX_LENGTH) {
      this.usernameError = USER_NAME_MAX_LENGTH_MSG;
      this.refreshCaptcha();
    } else {
      this.usernameError = '';
    }
  }

  onResetErrors(includeAllErrors: boolean): void {
    if (includeAllErrors) {
      this.usernameError = '';
      if (this.environment !== DEV_PROFILE) {
        this.captchaCompo.invalidCaptchaErr = '';
      }
    }
    this.passwordError = '';
    this.loginError = '';
  }

  refreshCaptcha(): void {
    if (this.environment !== DEV_PROFILE) {
      this.captchaCompo.createCaptcha();
    }
  }
}
